export default "__VITE_ASSET__BAiK_me0__"